import styled from "styled-components";
import {LiveCasinoNavbarDefaultBox} from "./live-casino-navbar.default.box";
import {baseColors} from "../../../../../../themes/definitions/casino888/cis/base-colors";

export const LiveCasinoNavbarCisBox = styled(LiveCasinoNavbarDefaultBox)`
  background: ${baseColors.gray043};
`;